import { infos } from '@/components/rightTool/data/info.js'

const DEFAULT_TITLE = '宏景云平台'
const DEFAULT_DESC = '致力于打造中国人才发展生态链，让人尽其才，才尽其用！'

let userStoriesLoadPromise = null

/**
 * 拉取典型用户 JSON 并填充 infos 中 userStories?userName=xxx 的 title/desc，只请求一次。
 * 供 updateShareMeta 与 RightTool 分享时使用。
 */
export async function ensureUserStoriesInfos() {
  if (userStoriesLoadPromise) return userStoriesLoadPromise
  userStoriesLoadPromise = (async () => {
    try {
      const response = await fetch(
        '/jx/images/platform/homepage/typicalUsers/typicalUsers.json?' +
        new Date().getTime()
      )
      if (!response.ok) {
        throw new Error(`HTTP错误! 状态: ${response.status}`)
      }
      const caseList = await response.json()
      for (const key in caseList) {
        const list = (caseList[key] || []).filter((child) => child.isCase == 1)
        list.forEach((casc) => {
          const k = 'userStories?userName=' + casc.caseUrl
          infos[k] = {
            title: '宏景云平台-' + casc.name,
            desc: casc.userDesc
          }
        })
      }
    } catch (err) {
      console.error('Fetch错误:', err)
    }
  })()
  return userStoriesLoadPromise
}

function setMeta(nameOrProperty, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name'
  let el = document.querySelector(`meta[${attr}="${nameOrProperty}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, nameOrProperty)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content || '')
}

/**
 * 根据当前路由更新页面 title 与分享用 meta（og:url、og:title、og:description 等），
 * 使浏览器分享或链接被粘贴到社交软件时，卡片能带上当前页标题、描述和网址。
 */
export async function updateShareMeta(route) {
  if (!route) return

  let key = route.name
  if (route.name === 'userStories' && route.query && route.query.userName) {
    key = 'userStories?userName=' + route.query.userName
  }

  if (key && String(key).includes('userStories')) {
    await ensureUserStoriesInfos()
  }

  const info = key ? infos[key] : null
  const title = (info && info.title) || DEFAULT_TITLE
  const desc = (info && info.desc) || DEFAULT_DESC
  const url = window.location.href || ''

  document.title = title

  setMeta('description', desc)
  setMeta('og:title', title, true)
  setMeta('og:description', desc, true)
  setMeta('og:url', url, true)
}
